<template>
  <div class="template-container">
    <vue-confirm-dialog/>
    <IONotifications/>
    <SettingsModal/>
    <GlobalModal/>
    <GlobalDrawer/>
    <site-header :searchByMenu="searchUpdated"/>
    <site-sidebar type="basic" v-if="usersRoles" :usersRoles="usersRoles" :filterMenuByText="searchText"/>
    <SideModal
      v-if="SideModalData && SideModalData.open"
      :data="SideModalData"
    />
    <sideBarOrderModal
      v-if="orderModalData.open"
      :modalData="orderModalData"
      :onModalClose="() => this.orderModalData = {}"
      :fetchOrders="() => {}"
    />
    <sideBarInvoiceModal
      v-if="invoiceModalData.open"
      :modalData="invoiceModalData"
      :onModalClose="() => this.invoiceModalData = {}"
      :fetchOrders="() => {}"
    />
<!--    <transition name="fade" mode="out-in">-->
      <router-view/>
<!--    </transition>-->
    <!--    <site-footer/>-->
  </div>
</template>
<script type="text/babel">

import api from '@/api'
import SiteHeader from '@/views/layouts/partials/TheSiteHeader.vue'
import SiteFooter from '@/views/layouts/partials/TheSiteFooter.vue'
import SiteSidebar from '@/views/layouts/partials/TheSiteSidebar.vue'
import sideBarOrderModal from '@/components/modals/orders/sideBarOrderModal'
import sideBarInvoiceModal from '@/components/modals/invoices/sideBarInvoiceModal'
import SettingsModal from '@/components/users/SettingsModal'
import GlobalModal from '@/components/modals/GlobalModal'
import IONotifications from '@/components/notifications/IONotifications'
import SideModal from "@/components/modals/SideModal";
import GlobalDrawer from "@/components/modals/GlobalDrawer";

export default {
  computed: {
    sideModalData() {
      return this.$store.getters['modals/sideData']
    },
    usersRoles() {
      return this.$store.getters['user/currentUserRoleId']
    },
    orderToEdit() {
      return this.$store.getters['orders/orderToEdit']
    },
    invoiceToEdit() {
      return this.$store.getters['invoices/invoiceToEdit']
    },
  },
  components: {
    IONotifications,
    SiteHeader, SiteSidebar, SiteFooter,
    sideBarOrderModal,
    sideBarInvoiceModal,
    SettingsModal,
    GlobalModal,
    SideModal,
    GlobalDrawer,
  },
  watch: {
    'sideModalData': {
      handler: function (val, oldVal) {
        if (val) {
          this.SideModalData = {...val, open: true}
        }
      },
      deep: true
    },
    'orderToEdit': {
      handler: function (val, oldVal) {
        if (val && val.orderId) {
          this.orderModalData = {...val, open: true}
        } else {
          this.orderModalData = {};
        }
      },
      deep: true
    },
    'invoiceToEdit': {
      handler: function (val, oldVal) {
        this.invoiceModalData = {...val, open: true}
      },
      deep: true
    },
  },
  mounted() {
    this.$utils.setLayout('default')
  },
  data() {
    return {
      globalEmptyModal: false,
      searchText: null,
      orderModalData: {},
      invoiceModalData: {},
      SideModalData: null,
    }
  },
  methods: {
    searchUpdated(search) {
      this.searchText = search ? search : null
    }
  }
}
</script>
